export default "__VITE_ASSET__3dc7dc62__"